export default __webpack_public_path__ + "static/media/avatar9-mujer.d2cd95ad.png";